export default "__VITE_ASSET__CfNQL3By__";